import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {Community} from "../_types/communities";

export interface VideoLink {
    type: string;
    id: string | null;
    link: SafeResourceUrl;
    src: string;
}

export function videoLinkUpload(link: string | null, domSanitizer: DomSanitizer): VideoLink | null {
    if (!link) {
        return null;
    }

    link = link.replace(/(<([^>]+)>)/gi, "");

    if (link.includes('youtube')) {
        const type: "youtube" = 'youtube';
        const [protocol, , id] = link.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/|live\/)/);
        const videoId: string | null = id?.split(/[^0-9a-z_-]/i)[0] || null;
        const videoLink: SafeResourceUrl = domSanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + videoId + '?autoplay=0');
        return {type, id: videoId, link: videoLink, src: ''};
    } else if (link.includes('vimeo')) {
        const type: "vimeo" = 'vimeo';
        const matches = link.match(/(?:vimeo)\.com\/(?:video\/|channels\/\w+\/|groups\/\w+\/videos\/|album\/\d+\/video\/|)\/?(\d+)/);
        const id: string | null = matches && matches[1] ? matches[1] : null;
        if (!id) {
            console.error('Could not extract Vimeo ID from URL:', link);
            return null;
        }
        let url: string = 'https://player.vimeo.com/video/' + id + '?autoplay=0&controls=1'

        let community: Community | null = null;
        let localCommunity = localStorage.getItem('lastSelectedCommunity')
        if (typeof localCommunity == 'string') {
            community = JSON.parse(localCommunity)
            if (community?.accent_color_hex) {
                url = url + '&color=' + community.accent_color_hex.substring(1);
            }
        }

        const videoLink: SafeResourceUrl = domSanitizer.bypassSecurityTrustResourceUrl(url);
        return {type, id, link: videoLink, src: ''};
    } else {
        const videoLink: SafeResourceUrl = domSanitizer.bypassSecurityTrustResourceUrl(link);
        return {type: 'api', id: null, link: videoLink, src: ''};
    }
}
